import React from "react";
import {  useCallback,useMemo } from "react";
import { LocaleContext } from "../context"
import { graphql, useStaticQuery } from "gatsby"
import { localizedPath } from "../helpers"

 


const useLocalization = () => {
  const { locale, message , setMessage, originalPath } = React.useContext(LocaleContext);

  const {
    themeI18N: { defaultLang, config }
  } = useStaticQuery(graphql`
    query LocalizationConfigQuery {
      themeI18N {
        defaultLang
        config {
          code
          hrefLang
          dateFormat
          langDir
          localName
          name
          prefix
          region
        }
      }
    }
  `)

  const addString = useCallback((namespace,arrays) => {
    if(typeof message === "undefined")
      return

    let tempObj = message;
    
    if(arrays.length)
    {
      arrays.forEach((item) => {
        tempObj[`${namespace}.${item.key}`] = item;
      });
      
    } else {
      config.forEach((lang) => {
        Object.keys(arrays[lang.prefix]).forEach((keys) => {
          if(!tempObj[`${namespace}.${keys}`])
            tempObj[`${namespace}.${keys}`] = {}
          tempObj[`${namespace}.${keys}`][lang.code.replace(/-/g,'_')] = arrays[lang.prefix][keys];
        })
      });
    }

    setMessage(tempObj);
    
  },[message,setMessage,config]);  

  const t = useCallback((key) => {
    if(typeof message === "undefined")
      return

    if(typeof message[key] !== "undefined")
    {
      let string = message[key][locale.replace(/-/g,'_')];
      if(message[key][locale.replace(/-/g,'_')] === null)
        return;
      let replacement = string.match(/\{(.*?)\}/gm);
      if(replacement)
      {
        replacement.forEach((item) => {
          var replaceKey = item.slice(1,item.length-1);
          if(typeof message[replaceKey] !== "undefined")
          {
            string = string.replace(item,message[replaceKey][locale.replace(/-/g,'_')]);
          }
        })
      }
      return string;
    }
    else
      return "";
  },[message,locale]); 


  const currentLocaleObj = useMemo(
    () => config.filter(item => item.code === locale)[0],
  [locale,config]);  

  const localeKey =  useMemo(
    () => locale.replace(/-/g,'_'),
  [locale]);  

  return {
    locale,
    defaultLang,
    config,
    localizedPath,
    t,
    addString,
    message,
    originalPath,
    currentLocaleObj,
    localeKey
  }
}

export { useLocalization }
